import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MaterialModule } from '../../material/material.module';
import { PanelPropuestasComponent } from './panel-propuestas.component';
import { AccionesPropuestaModule } from '../acciones-propuesta/acciones-propuesta.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InicialesModule } from '../../iniciales/iniciales.module';
import { DragulaModule } from 'ng2-dragula';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  declarations: [
    PanelPropuestasComponent
  ],
  imports: [
    CommonModule,
    NgxPermissionsModule.forChild(),
    MaterialModule,
    AccionesPropuestaModule,
    ReactiveFormsModule,
    FormsModule,
    InicialesModule,
    DragulaModule.forRoot(),
    PerfectScrollbarModule
  ],
  exports: [
    PanelPropuestasComponent
  ],
  entryComponents: [
    PanelPropuestasComponent
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ]

})
export class PanelPropuestasModule { }
